"use client"
import React, { useState, useMemo } from 'react'
import AwardCard from './AwardCard'
import useFetch from '@/app/useFetch'
import Pegination from './Pegination'
import Loader from './Loader'

const ChiefMinAward = ({ slug }) => {


    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(12)
    const [selectedYear, setSelectedYear] = useState("")

    const yearOptions = useMemo(() => {
        const years = [];
        const currentYear = new Date().getFullYear();  // <-- AUTO UPDATES EVERY YEAR

        for (let i = 0; i <= 20; i++) {
            years.push(currentYear - i);
        }
        return years;
    }, []);

    const { data: list, totalPages, loading } = useFetch(
        `/website/vigilance-awards/${slug}`,
        {
            page: currentPage,
            limit: limit,
            year: selectedYear
        },
        [currentPage, limit, selectedYear,slug]
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
        setCurrentPage(1); // Reset on year change
    };

    return (
        <section className="mt-40">
            <div className="row mb-3 justify-content-end">
                <div className="search-box d-flex align-items-center">
                    <select value={selectedYear} onChange={handleYearChange}>
                        <option value="">All Years</option>
                        {yearOptions.map((yr) => (
                            <option key={yr} value={yr}>{yr}</option>
                        ))}
                    </select>
                </div>
            </div>
            {loading ? (
                <>
                    <Loader n={24} f={0.3} />

                </>
            ) : <>
                <div className='row row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-4'>
                    {list?.map((item, index) => (
                        <AwardCard
                            key={index}
                            name={item.name}
                            designation={item.designation}
                            img={item.photo}
                            detail={item.description}
                            yer={item.year}
                        />
                    ))}
                </div>

                {totalPages > 1 && (
                    <Pegination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}

            </>}
        </section>
    );
};

export default ChiefMinAward;
